import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent, createRef } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';

import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';

import * as Utilities from "./Utilities"

import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";
import { create } from "domain";

import * as Tree from 'react-dropdown-tree-select'
import DropdownTreeSelect from 'react-dropdown-tree-select'


import './NavTree.css'


export enum EbenenTyp     {
    Produkt = 1,
    Gruppierung,
    FreieEbenen 
}

type State = {
    ready: boolean,
    expanded: string[],
    selected: KSLPlusAPI.HaushaltsHiearchieDoppik | undefined,
    suchtext: string,
    stopUpdates: boolean

}

type Props = {    
    hh: KSLPlusAPI.HaushaltsHiearchieDoppik,
    //hh2: KSLPlusAPI.HaushaltsEbene
    onSelChange: (ebene: KSLPlusAPI.HaushaltsHiearchieDoppik, suchtext: string, selected: string) => void,
    onMultiSelChange: (ebene: KSLPlusAPI.HaushaltsHiearchieDoppik[], suchtext: string, selected: string) => void,    
    showNumber: boolean,
    selected: string|undefined,
    typ: EbenenTyp,
    auswahlText: string,
    multiSelect: boolean
}



export class ProduktNavTree extends Component<Props, State> {
    constructor(props: any) {
        super(props);
                
    }

    treeRef = createRef<DropdownTreeSelect>();
    observer?: MutationObserver;
    
    node: any;
    

    state: State = {
        ready: false,
        expanded: ["1"],
        selected: undefined,
        suchtext: "",
        stopUpdates: false
    }

    static defaultProps = {     
        multiSelect: false,
        onSelChange: () => { },
        onMultiSelChange: () => { }
    }

    componentDidMount() {

        const input = this.treeRef.current?.searchInput;

        if (input) {

            input.addEventListener("input", this.handleSearchInput);
        }

        const node = this.treeRef.current?.node;

        if (!node) {
            return;
        }

        
        this.observer = new MutationObserver(() => {

            const dropdown =
                node.querySelector(
                    ".dropdown-content"
                ) as HTMLElement | null;

            if (!dropdown ) 
                this.setState({ suchtext: "", stopUpdates: false });
            else if ( this.state.suchtext !== "")
                this.setState({ stopUpdates: true });

        });

        this.observer.observe(node, {
            attributes: true,
            attributeFilter: [
                "class",
                "style"
            ],
            subtree: true
        });
    }

    
    componentWillUnmount() {

        this.observer?.disconnect();

        const input = this.treeRef.current?.searchInput;

        if (input) {

            input.removeEventListener("input", this.handleSearchInput);
        }
    }

    shouldComponentUpdate = (nextProps: Props) => {
        if (this.state.stopUpdates)
            return false;
        return true;
    }


    handleSearchInput = (e: Event) => {
        
        const target = e.target as HTMLInputElement;

        this.state.stopUpdates = this.state.stopUpdates && (target.value ?? "") !== "";
        this.setState({
            suchtext: target.value
        });
        if ((target.value ?? "") === "")
            this.forceUpdate();
    };

    
    searchPredicate = (node: any, searchTerm: string): boolean => {                
        var res = node.label.toLowerCase().indexOf(searchTerm) >= 0;
        
        if ( res )
            return true;

        
        if ( node.customData  )
        {   
            var ebene = (node.customData as KSLPlusAPI.HaushaltsHiearchieDoppik);
            if ( ebene )
            {                
                if ( ebene.beschreibung && ebene.beschreibung.toLowerCase().indexOf(searchTerm) >= 0 )
                    return true;
                /*
                // durch Haushaltsstellen, wenn wir bereits auf der Buchungsebene sind
                if ( !node.children && ebene.unterEbenen )
                {                                                    
                    ebene.unterEbenen.every( ue => {                        
                        if ( ue.beschreibung && ue.beschreibung.toLowerCase().indexOf(searchTerm) >= 0 )
                        {
                            res = true;
                            return false;
                        }
                    });
                }                
                */
            }            
        }

        return res;
    }

    
    createTreeData = (ebenen: KSLPlusAPI.HaushaltsHiearchieDoppik[], parent: KSLPlusAPI.HaushaltsHiearchieDoppik|undefined, tagLabel: string) => {
        var data: Tree.TreeNode[] = [];
       
        ebenen.forEach( ebene => {
            var bezeichnung = ebene.bezeichnung;
            var label = "";
            
            
            if ( !ebene.unterEbenen )
                return;
           

            //if (!ebene.ergebnisVvJ_soll && !ebene.ansatzVJ_soll && !ebene.ansatzPj_soll && !ebene.ansatzPj_soll && !ebene.fp2_soll && !ebene.fp3_soll && !ebene.ergebnisVvJ_haben && !ebene.ansatzVJ_haben && !ebene.ansatzPj_haben && !ebene.ansatzPj_haben && !ebene.fp2_haben && !ebene.fp3_haben) 
              //  return;

            var num = "";
            var selector = "";
            if ( this.props.typ == EbenenTyp.FreieEbenen )
            {   
                if ( !(this.props.hh.ebene?.keineNummer ?? false) )
                    num = ebene.ebenenNr !== undefined && ebene.ebenenNr != null ? Utilities.Num2Str(ebene.ebenenNr, ebene.ebenenStellen ? ebene.ebenenStellen : 0) : "";
                selector = ebene.ebenenId ?? "";
            }
            else
            {
                num = ebene.produkt !== undefined && ebene.produktStellen !== undefined ? Utilities.Num2Str(ebene.produkt, ebene.produktStellen) : "";                    
                selector = num;
            }
            if ( this.props.showNumber )               
                label = num.length ? num + " - " : "";  
            

            label = label + (bezeichnung != null && bezeichnung.length > 0 ? bezeichnung : ebene.bezeichnung);
            
            var item: Tree.TreeNode = { label: label, value: label, ebene: ebene, parent: parent, tagLabel: this.props.multiSelect ? label : (tagLabel + label), customData: ebene}


            if (this.props.multiSelect && ebene.selected) {
                item.checked = true;
                //item.expanded = true;
            }
            else if (!this.props.multiSelect && this.props.selected === selector) {                
                item.checked = true;
                item.expanded = true;
            }

            /*
            if ( num === this.props.selected )
            {                   
                item.checked = true;     
                item.expanded = true;           
            }
            */
                                                          
            
            
            item.children = this.createTreeData(ebene.unterEbenen, ebene, item.tagLabel + " > ");
            for ( var i = 0; i < item.children.length; i++ )
            {
                if ( item.children[i].expanded )
                {
                    item.expanded = true;
                    break;
                }
                if (this.props.multiSelect) {
                    if (item.children[i].checked) {
                        item.expanded = true;
                        break;
                    }
                }
            } 
            data.push(item);
            
        });
        return data;
    }

    updateSelectState = (ebenen: KSLPlusAPI.HaushaltsHiearchieDoppik[], selected: KSLPlusAPI.HaushaltsHiearchieDoppik[]) => {
        ebenen.forEach(ebene => {
            ebene.selected = selected.findIndex(e => e.id === ebene.id) !== -1;



            // für freie ebenen keine selektion der Elternknoten zulassen
            //if ( this.props.typ == EbenenTyp.FreieEbenen )
            //  item.disabled = true;
            if (ebene.unterEbenen) {
                this.updateSelectState(ebene.unterEbenen, selected);
            }
        });
    }

    updateSelectStateByStr = (ebenen: KSLPlusAPI.HaushaltsHiearchieDoppik[], selected: string[]) => {
        ebenen.forEach(ebene => {
            var selStr = "";
            if (this.props.typ == EbenenTyp.FreieEbenen)
                //selStr = Utilities.Num2Str(ebene.ebenenNr, ebene.ebenenStellen);
                selStr = ebene.ebenenId ?? "";
            else
                selStr = Utilities.Num2Str(ebene.produkt, ebene.produktStellen);
            
            ebene.selected = selected.findIndex(e => e === selStr) !== -1;

            if (ebene.unterEbenen) {
                this.updateSelectStateByStr(ebene.unterEbenen, selected);
            }
        });
    }


    
    handleTreeClick = (data: Tree.TreeNode, selected: Tree.TreeNode[]) => {            
        selected = selected.filter(s => s.ebene.id !== this.props.hh.id);      
        var selStr = "";
        if (this.props.typ == EbenenTyp.FreieEbenen)
            //selStr = selected.map(s => Utilities.Num2Str(s.ebene.ebenenNr, s.ebene.ebenenStellen)).join(",");            
            selStr = selected.map(s => s.ebene.ebenenId).join(",");            
        else
            selStr = selected.map(s => Utilities.Num2Str(s.ebene.produkt, s.ebene.produktStellen)).join(",");
        
        
        if (this.props.multiSelect) {
            if (data.ebene.id === this.props.hh.id && selected.length !== 0) {
                selected = [data];
                this.props.hh.selected = true;
                this.props.onSelChange(this.props.hh, this.state.suchtext, ",");
                this.updateSelectState(this.props.hh?.unterEbenen ?? [], selected.map(s => s.ebene));
                this.setState({ ready: true });                
                return;
            }
            else {
                this.props.hh.selected = selected.length === 0;

                if (selected.length === 0) {
                    this.props.onSelChange(this.props.hh, this.state.suchtext, ",");
                    this.updateSelectState(this.props.hh?.unterEbenen ?? [], selected.map(s => s.ebene));
                    this.setState({ ready: true });                    
                    return;
                }

            }
            if (selected.length > 0) {
                this.state.selected = data.ebene;
                this.props.onMultiSelChange(selected.map(s => s.ebene), this.state.suchtext, selStr + ",");
                //this.state.suchtext = "";
            }
            else if (data.parent) {
                this.state.selected = data.ebene;
                this.props.onSelChange(this.props.hh, this.state.suchtext, ",");
                //this.props.onSelChange(data.parent, this.state.suchtext);
                //this.state.suchtext = "";
            }
        }
        else {
            if (selected.length > 0) {                
                this.state.selected = data.ebene;
                this.props.onSelChange(data.ebene, this.state.suchtext, selStr);
                this.state.suchtext = "";
            }
            else {
                this.state.selected = data.ebene;
                this.props.onSelChange(this.props.hh, this.state.suchtext, "");
                //this.props.onSelChange(data.parent, this.state.suchtext);
                this.state.suchtext = "";
            }
        }
        /*
        if ( selected.length > 0  )       
        {
            this.state.selected = data.ebene;
            this.props.onSelChange(selected[0].ebene, this.state.suchtext);
            this.state.suchtext = "";
        }
        else if ( data.parent )
        {
            this.state.selected = data.ebene;
            this.props.onSelChange(this.props.hh, this.state.suchtext);
            //this.props.onSelChange(data.parent, this.state.suchtext);
            this.state.suchtext = "";
        }
        */
        this.updateSelectState(this.props.hh?.unterEbenen ?? [], selected.map(s => s.ebene));
        this.setState({ ready: true });        
    }
    
    
    render() {
        if (!this.props.hh.unterEbenen)
            return null;

        var treedata: Tree.TreeNode[]; 
        
        if (!this.props.multiSelect && !this.props.hh.verbergen )
        {
            var main: Tree.TreeNode = {label: "Gesamthaushalt", value: "Gesamthaushalt", ebene: this.props.hh, parent: undefined, expanded: true}; 
            
            /*
            var num = "";
            
            if ( this.props.typ == EbenenTyp.FreieEbenen )
            {   
                num = this.props.hh.ebenenNr !== undefined && this.props.hh.ebenenNr !== null ? Utilities.Num2Str(this.props.hh.ebenenNr, this.props.hh.ebenenStellen ? this.props.hh.ebenenStellen : 0) : "";
            }
            else
            {                
                num = this.props.hh.produkt !== undefined && this.props.hh.produktStellen !== undefined ? Utilities.Num2Str(this.props.hh.produkt, this.props.hh.produktStellen) : "";
            }
            */
        
            if ( this.props.selected === "" || this.props.selected === this.props.hh.ebenenId)
            {
                //main.isDefaultValue = true;
                main.checked = true;            
            
            }
            main.children = this.createTreeData(this.props.hh.unterEbenen, this.props.hh, "");
            treedata = [main];            
        }        
        else {
            this.updateSelectStateByStr(this.props.hh.unterEbenen, (this.props.selected ?? "").split(','));
            treedata = this.createTreeData(this.props.hh.unterEbenen, undefined, "");
            if (this.props.multiSelect) {
                var main: Tree.TreeNode = { label: "Gesamthaushalt", value: "Gesamthaushalt", ebene: this.props.hh, parent: undefined, expanded: true, disabled: (this.props.selected ?? ",").replace(",", "") === "" };
                if ((this.props.selected ?? ",").replace(",", "") === "")
                    main.checked = true;
                if (this.props.hh.selected)
                    this.updateSelectState(this.props.hh.unterEbenen, []);
                treedata = [main].concat(treedata);
            }

        }


        

        return (
            <DropdownTreeSelect ref={this.treeRef} className="kslplus-haushalts-treeselect" data={treedata} mode={this.props.multiSelect ? "multiSelect" : "radioSelect"} texts={{ placeholder: this.props.auswahlText, noMatches: "Kein Treffer" }} keepTreeOnSearch={true} searchPredicate={this.searchPredicate} onChange={this.handleTreeClick} />            
          );
    }
}